module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0201",
      "epub:type": "chapter",
      "id": "ch02",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0201"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "28",
      "id": "p28",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "29",
      "id": "p29",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0007#rch02"
    }
  }, [_vm._v("Who Owns Carrie Fisher?")])]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("A Complicated Embodiment of Manufactured Commodity and Avatar of Resistance")]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_vm._v("Jennifer M. Fogel")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n her bawdy 2005 American Film Institute roast of "), _c('i', [_vm._v("Star Wars")]), _vm._v(" director George Lucas, Carrie Fisher sarcastically lamented Lucas’s complete appropriation of her likeness in perpetuity. In what would soon become a comedic calling card for the remainder of her life, Fisher caustically announced that among “George’s many possessions, he owns my "), _c('i', [_vm._v("likeness")]), _vm._v(", so that every time I look in the mirror I have to send him a couple of bucks!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en42",
      "id": "en42r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" Fisher’s image as Princess Leia has been commodified to the point that—as she herself told "), _c('i', [_vm._v("Newsweek")]), _vm._v(" in 2011—it eclipses any other persona the actress and novelist had fought to create."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en43",
      "id": "en43r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" The "), _c('i', [_vm._v("Star Wars")]), _vm._v(" franchise not only triggered a new investment in film licensing for various merchandise, but in its forty-plus-year history it has also spurred a long-lasting trend of fan collectability. Running parallel to the franchise’s success and reinvention, Fisher—a collector of kitsch, memorabilia, and fan-made gifts—was able to navigate eccentric and grotesque seizures of her image through humor and a biting wit.")]), _vm._v(" "), _c('p', [_vm._v("But what does it mean when your likeness is no longer your own? When it becomes a paradox of reverie and parody? On the one hand, Fisher remains a pin-up girl for male fanboys, and on the other, the embodiment of a feminist icon. While her Princess Leia persona is a highly contested catalog of hyperfeminized attributes (e.g., the inexhaustible discussion of Leia’s hair and the “golden metal bikini”) that have leeched into the gendered marketing of "), _c('i', [_vm._v("Star Wars")]), _vm._v(" products for forty years, General Leia—Fisher’s contemporary incarnation within the franchise—was met with a misogynistic disparagement of the actress’s aged physique. The lambasting of a sci-fi sex "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "30",
      "id": "p30",
      "role": "doc-pagebreak"
    }
  }), _vm._v("symbol for “getting older” is a toxic reminder that Fisher’s image has been annexed and commodified by a largely nostalgic (male) fandom.")]), _vm._v(" "), _c('p', [_vm._v("In a day and age where celebrity is both a cultural fashion and an economic consumer trade, the complicated reification of Fisher’s image—both as Princess Leia and as herself—has largely defined generations of "), _c('i', [_vm._v("Star Wars")]), _vm._v(" fandom. But who owns Carrie Fisher? The character she embodied long ago in a galaxy far, far away may be a cultural icon, but Fisher, for all intents and purposes, brought Princess Leia to life, thoroughly promoted—if at times unwillingly—and sustained audience interest in the character, and managed to imbue the beloved princess with an authenticity unparalleled even within the expanded "), _c('i', [_vm._v("Star Wars")]), _vm._v(" universe. Carrie Fisher was a successful novelist and script doctor beyond her sci-fi roots, but her celebrity status was coauthored by a burgeoning use of movie tie-in merchandise and the fans that consumed these cultural commodities. The conflation of Carrie Fisher and Princess Leia only intensifies the maddening entanglement of fans’ imagined cultural ownership of Fisher’s likeness (as Leia, of course) in the form of collectibles and licensed merchandise put forth by the marketing agents that financially "), _c('i', [_vm._v("own")]), _vm._v(" her “likeness.” All this being a lamentable consequence of Fisher “blithely sign[ing] away any and all merchandising rights relating to [her] image and otherwise” before the premiere of the first "), _c('i', [_vm._v("Star Wars")]), _vm._v(" film in 1977."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en44",
      "id": "en44r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', [_vm._v("This chapter draws extensively from two of Carrie Fisher’s autobiographies—"), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(" (2008) and "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(" (2016)—and numerous interviews with the actress about her iconic role. Always full of acerbic wit and a brazen ease with truth-telling, Fisher’s writing avails both fans and academics with a sophisticated and fascinating reverie of her bumpy road to and with fame. Underscoring each biting truism and (sometimes) scandalous memory is a complex rumination on what her celebrity means for herself and to her adoring fans. This chapter first examines the ways in which Carrie Fisher’s character served as both goddess and warrior for a burgeoning fandom but whose likeness was appropriated to sell hyperfeminized products to these same fans. Next, a discussion of Fisher’s complicated love-hate relationship with her iconic character, particularly the body shaming she endured by both George Lucas and the fandom. Lastly, the chapter contemplates how an emboldened Women’s March in January 2017 wrested control of Fisher’s image away from corporate owners after her unexpected death and finally redeemed this warrior princess in a way her portrayer would be proud of.")]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0201"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "31",
      "id": "p31",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Fan Consumption of the Commodified Image")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As the story is so often told, George Lucas saw past the Hollywood machine and with cunning foresight not only negotiated the sequel rights to one of the most successful film serials in history but also 100 percent of the merchandising rights."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en45",
      "id": "en45r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])]), _vm._v(" Now one of the highest-grossing films of all time, most of the success of this megafranchise is due to the massive amount of merchandise the films produced, selling more than $100 million worth of toys within a year after "), _c('i', [_vm._v("Star Wars: A New Hope")]), _vm._v("’s 1977 release."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en46",
      "id": "en46r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" To date, "), _c('i', [_vm._v("Star Wars")]), _vm._v(" licensed toys and merchandise sales have earned $12 billion for the franchise—nearly triple the box office revenue from the original and prequel trilogy films combined."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en47",
      "id": "en47r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])]), _vm._v(" Referring to this groundbreaking explosion of movie tie-in products, Carrie Fisher wrote in "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(" (2016), the film “leaked out of the theater, poured off the screen, [and] affected a lot of people so deeply that they required endless talismans and artifacts to stay connected to it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en48",
      "id": "en48r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" As paratextual materials, the action figures, novelizations, comics, clothing, and such, all became essential in facilitating enjoyment, loyalty, and later, nostalgia within the "), _c('i', [_vm._v("Star Wars")]), _vm._v(" fan base.")]), _vm._v(" "), _c('p', [_vm._v("Carrie Fisher herself recounts in "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(" the litany of products to bear her likeness:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("George Lucas was the man who made me into a little doll! And it barely even hurt. A little doll that one of my exes could stick pins into whenever he was annoyed with me. . . . He also made me into a shampoo bottle where people could twist off my head and pour liquid out of my neck. . . . And there was a soap that read, “Lather up with Leia and you’ll feel like a Princess yourself.” . . . But the thing I’ve been made into that has really enhanced the quality of my life? I’m a PEZ dispenser."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en49",
      "id": "en49r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Importantly, these products were not simply tokens of a popular film character but invoked the now-infamous visage of Princess Leia styled by creator George Lucas. As noted by Fisher in "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(", the cinnamon bun hairstyle she grudgingly complied with for fear of being sacked from "), _c('i', [_vm._v("A New Hope")]), _vm._v(", “would impact how everyone—every filmgoing human—would envision me for the rest of my life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en50",
      "id": "en50r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" She also admits, she “definitely would have argued against that insane hair (although the hair was, in its own modest way, a big part of that noise).”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en51",
      "id": "en51r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "32",
      "id": "p32",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Of course, the hotly debated skimpy metal bikini slave outfit she wears in "), _c('i', [_vm._v("Return of the Jedi")]), _vm._v(" (1983) often overshadows Princess Leia’s initial iconic look and otherwise reserved fashion. Whether the bikini was Lucas’s “cynical nod” to “his growing nerd culture fan base,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en52",
      "id": "en52r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])]), _vm._v(" a crude objectification of the heroine, or an ironic and empowered spin on the damsel in distress trope—Leia does use the elements of her enslavement to kill her captor"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en53",
      "id": "en53r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v("—the controversial outfit is now a commodified cultural artifact symbolic for both modern-day cosplaying and constructed Princess Leia as a (nostalgic) sci-fi sex symbol. Herein lies the rub; at the same time that Lucas was successfully leveraging the toyetic nature of his "), _c('i', [_vm._v("Star Wars")]), _vm._v(" films and commodifying the likeness of each of his actors, the fan base became a highly gender constrictive landscape overseen by the twin suns of toy marketers and merchandising agents.")]), _vm._v(" "), _c('p', [_vm._v("Despite featuring a smart and sassy princess as one of its lead characters, within the geek kingdom that "), _c('i', [_vm._v("Star Wars")]), _vm._v(" has become there is an oft-refused and marginalized fandom of women, as detailed by Philipp Dominik Keidl in the following essay in this anthology. The realms of science fiction and fantasy have traditionally, though wrongly, been assumed to "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "33",
      "id": "p33",
      "role": "doc-pagebreak"
    }
  }), _vm._v("belong to the male fan domain. Scholars detail how fandom is often highly pigeonholed into very gendered aspects of fan creativity and practices of fan consumption."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en54",
      "id": "en54r",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])]), _vm._v(" While women may be “fans” of "), _c('i', [_vm._v("Star Wars")]), _vm._v(", they are not its target market: “This is not to say that female fans have not been a power in the consumption of "), _c('i', [_vm._v("Star Wars")]), _vm._v(" merchandise, just that more toys are produced with male consumers in mind.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en55",
      "id": "en55r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0201"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "400",
      "src": "images/wsu-mizejewski-fig0201.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p32"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0008#rfig0201"
    }
  }, [_vm._v("Fig. 2.1.")])]), _vm._v(" A representation of the litany of collectibles bearing Carrie Fisher’s likeness can be seen in Mary’s ever-growing “Leia Land.”")])]), _vm._v(" "), _c('p', [_vm._v("As of late, critics and scholars alike have taken to task the undeniably gendered impetus of Lucasfilm (and now, Disney), its texts and supplementary merchandise, and the more general dismissal of women favoring sci-fi and fantasy. This marginalization was solidified early in the countless television ads hawking toys for the original trilogy that rarely featured any little girls playing with Leia action figures (or even dolls) and emphasized the franchise as a “boy thing,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en56",
      "id": "en56r",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" combined with the few hyperfeminized products that were available for girls and women including Princess Leia bubble bath, dolls, costumes, wigs, and, perhaps the most egregious, a Slave Leia perfume from 1983 that was “reissued” for fans anew at the 2010 "), _c('i', [_vm._v("Star Wars")]), _vm._v(" Celebration festival.")]), _vm._v(" "), _c('p', [_vm._v("According to journalist Peter Beech, “The sci-fi genre is designed, it seems, for feminist ideas, offering us the chance to imagine a place free of gender-stereotyping and sexism.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en57",
      "id": "en57r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" In fact, audiences for sci-fi/fantasy films and television series have nearly achieved gender parity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en58",
      "id": "en58r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])]), _vm._v(" And yet, in his work on fandom, Joseph Reagle addresses how “geekdom” is on the one hand diverse and accepting and yet on the other offers a double bind for women, often accusing them of “being too geeky and not geeky enough.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en59",
      "id": "en59r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])]), _vm._v(" Hence, the overarching problem is that while female fans debate if Leia’s “slave” outfit in "), _c('i', [_vm._v("Return of the Jedi")]), _vm._v(" is objectifying or empowering—or why this iteration of Princess Leia is currently the most "), _c('i', [_vm._v("available")]), _vm._v(" form of "), _c('i', [_vm._v("her")]), _vm._v(" action figure—the marketing agents behind "), _c('i', [_vm._v("Star Wars")]), _vm._v("’ lineup of consumer products prior to and following the release of "), _c('i', [_vm._v("The Last Jedi")]), _vm._v(" of 2017 continue to “vastly underestimate the interest girls would have in the movies and related merchandise, and how toy buying has changed in the . . . years since the first "), _c('i', [_vm._v("Star Wars")]), _vm._v(" film was released.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en60",
      "id": "en60r",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])]), _vm._v(" Even as General Leia (and thus, Carrie Fisher) gave way to new heroine Rey (Daisy Ridley) in "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" in 2015, both characters were largely missing from toy shelves in favor of a line of CoverGirl cosmetics, jewelry at Kay Jewelers, kitchen goods, and a women’s clothing line from Rock & Republic for Kohl’s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en61",
      "id": "en61r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "34",
      "id": "p34",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Amid this tangled weaving of fan consumption, marketing, and gender, Carrie Fisher’s star turn as Princess Leia has become both cultural icon and commodified image. Despite being born into celebrity as the daughter of two famous individuals (i.e., actress Debbie Reynolds and crooner Eddie Fisher), with "), _c('i', [_vm._v("Star Wars")]), _vm._v(", Fisher was launched into a category beyond the traditional turn for an actress. She became the “simultaneous embodiment of media construction, audience construction, and the real, living and breathing human being.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en62",
      "id": "en62r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])]), _vm._v(" It was a plight she admits in "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(": she was wholly unprepared. But it was not the piles of fan mail, promotional interviews, or merchandise spreading her likeness across the globe that fazed her. It was the continual conflation and misappropriation of Carrie Fisher (actress) with that of Princess Leia (fictional character) by the fans writ large that contributed to a lifelong love-hate relationship with her iconic figure.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0202"
    }
  }, [_vm._v("Will the Real Princess Leia Please Stand Up?")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In his seminal work on celebrity, "), _c('i', [_vm._v("Heavenly Bodies: Film Stars and Society")]), _vm._v(", film scholar Richard Dyer argues that fans obsessively search the star persona for the real and the authentic. Carrie Fisher’s star persona consisted of a complex hodgepodge of manufactured appearances, paratextual commodities, and the screen image of Princess Leia. The “star image,” as noted by Dyer, is merely part of the Hollywood machine that both exploits the actress’s labor and yet, at the same time, divorces her "), _c('i', [_vm._v("self")]), _vm._v(" from the star persona."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en63",
      "id": "en63r",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])]), _vm._v(" Celebrity scholar P. David Marshall goes further, explaining that “as an audience we are drawn to deconstruct the star, and in that process . . . we are compelled to debate the nature of the star’s public and private selves.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en64",
      "id": "en64r",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])]), _vm._v(" Whereas most star images become further authenticated through the exploration of the "), _c('i', [_vm._v("real")]), _vm._v(" private self, Fisher’s off-screen foibles were repressed in favor of her “image’s popular currency.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en65",
      "id": "en65r",
      "role": "doc-noteref"
    }
  }, [_vm._v("24")])]), _vm._v(" Hence, Carrie Fisher is no longer the actress but the fictional icon she portrayed. Fans presume that this loss of autonomy is a reasonable trade-off for celebrity status, but it certainly constrained Fisher’s off-screen life and work as an actor.")]), _vm._v(" "), _c('p', [_vm._v("Both Dyer and Marshall examine the celebrity as commodity, one that “enters into the very lexicon of a culture, its personality instantiated and immortalized into caricature.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en66",
      "id": "en66r",
      "role": "doc-noteref"
    }
  }, [_vm._v("25")])]), _vm._v(" Dyer writes, “Stars appear before us in media texts . . . but unlike other forms of representation, stars do not only exist in media texts.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en67",
      "id": "en67r",
      "role": "doc-noteref"
    }
  }, [_vm._v("26")])]), _vm._v(" In most cases, celebrities are simply used to "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "35",
      "id": "p35",
      "role": "doc-pagebreak"
    }
  }), _vm._v("market goods to the masses; their selective endorsement is a sign of the presumed caliber of the product and a way to leverage both celebrity status and personal taste. As Marshall notes, stars possess both cultural and economic capital."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en68",
      "id": "en68r",
      "role": "doc-noteref"
    }
  }, [_vm._v("27")])]), _vm._v(" Unlike the young celebrities of today that can control the ways in which they leverage their star image—whether through social activism or commercial practices—Fisher’s image was fundamentally manufactured from the onset within a film franchise with a central impetus of commodification, which would later lead to its own cultural capital. Thus, Carrie Fisher becomes merely the body through which fans can assert their imagined ownership of and nostalgic participation in one of the biggest fan franchises of all time. But where does that leave Carrie Fisher who now uncomfortably navigates the conflation of her private self with the public persona that has been manufactured for her? Or worse, that the caricature of that persona—one now thoroughly and forever commodified—eclipses and dictates her life as an actor? For Carrie Fisher, celebrity was a perplexing duality of symbolic figure and corporate brand that left little separation for a private self or control of her likeness.")]), _vm._v(" "), _c('p', [_vm._v("Although legally the presumption is that the celebrity has a “right to publicity,” availing them recognition of the commercial value of their persona ranging from a signature to mannerism to frequently used phrases,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en69",
      "id": "en69r",
      "role": "doc-noteref"
    }
  }, [_vm._v("28")])]), _vm._v(" Carrie Fisher’s likeness (as Princess Leia in all iterations) is currently owned by Disney. The corporate appropriation of Fisher’s likeness has become increasingly problematic because not only is it constitutive of a global cultural commodity, but also its endless reproduction has forced her to lose any “autonomy from the objects that circulate in her likeness.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en70",
      "id": "en70r",
      "role": "doc-noteref"
    }
  }, [_vm._v("29")])]), _vm._v(" Furthermore, the visage of Princess Leia (as played by Fisher) has become part of our cultural heritage, and as legal anthropologist Rosemary Coombe argues, the “conditions that give her image its meaning, resonance, and authority” are generated from the imagined ownership of a passionate fan base spanning multiple generations that have shelled out money for merchandise and collectibles, stood in line waiting for autographs and selfies at conventions, and, more generally, affirmed the character’s iconic status through reverie and parody."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en71",
      "id": "en71r",
      "role": "doc-noteref"
    }
  }, [_vm._v("30")])]), _vm._v(" As noted by film scholar Jason Scott, “the fans themselves have . . . contributed to "), _c('i', [_vm._v("Star Wars")]), _vm._v(", not simply as consumers but participating in creating and producing the "), _c('i', [_vm._v("Star Wars")]), _vm._v(" culture.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en72",
      "id": "en72r",
      "role": "doc-noteref"
    }
  }, [_vm._v("31")])]), _vm._v(" He continues, “This is epitomized in the complementary ways "), _c('i', [_vm._v("Star Wars")]), _vm._v(" characters continue to be used, by both Lucas and the fans, as heroes and villains, mythic archetypes, icons, identities and objects "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "36",
      "id": "p36",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of affection.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en73",
      "id": "en73r",
      "role": "doc-noteref"
    }
  }, [_vm._v("32")])]), _vm._v(" As a consequence, the reification of Princess Leia as cultural commodity and Fisher’s celebrity status as a by-product, forms a paradoxical situation for the actress when meeting fans whereby they often fuse the two identities. Carrie Fisher, too, struggled to ascertain the configuration of her own identity: “This "), _c('i', [_vm._v("Star Wars")]), _vm._v(" fame meant that Princess Leia was famous and not Carrie Fisher. I just happened to look like her.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en74",
      "id": "en74r",
      "role": "doc-noteref"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', [_vm._v("As Fisher comments in the passage from "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(" quoted in this anthology’s introduction, she “"), _c('i', [_vm._v("liked")]), _vm._v(" being Princess Leia. Or Princess Leia’s being me. Over time I thought that we’d melded into one.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en75",
      "id": "en75r",
      "role": "doc-noteref"
    }
  }, [_vm._v("34")])]), _vm._v(" And in an interview with "), _c('i', [_vm._v("Newsweek")]), _vm._v(", she admitted, “Princess Leia so eclipses any other identity that I’ve ever had.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en76",
      "id": "en76r",
      "role": "doc-noteref"
    }
  }, [_vm._v("35")])]), _vm._v(" Carrie Fisher had all but disappeared into the creation of this meaningful cultural figure, but her custodianship was rife with personal insecurities and shaped by both corporate brand management and fan adoration. From the onset, Fisher was asked to conform to the lithe figure George Lucas had envisioned for his cinematic princess by not only losing ten pounds after she was cast in the role but also foregoing a brassiere in favor of gaffer’s tape to bind her breasts to her body."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en77",
      "id": "en77r",
      "role": "doc-noteref"
    }
  }, [_vm._v("36")])]), _vm._v(" The iconic hairstyle and, later, ambiguously objectified costume were both celebrated and considered crudely, though unexpectedly, masturbatory by the actress—as she equivocally expressed: “I had endless issues with my appearance in "), _c('i', [_vm._v("Star Wars")]), _vm._v(". . . . What I saw in the mirror is not apparently what many teenage boys saw.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en78",
      "id": "en78r",
      "role": "doc-noteref"
    }
  }, [_vm._v("37")])]), _vm._v(" Even though Fisher expressed surprise at her sex symbol status, she rationalized, “I think boys may have been attracted to my accessibility. . . . I wasn’t conventionally beautiful and sexy, and as such was less likely to put them down or think I was too good for them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en79",
      "id": "en79r",
      "role": "doc-noteref"
    }
  }, [_vm._v("38")])]), _vm._v(" As the physical embodiment of the sassy heroine and the sexy sci-fi princess, Fisher was tasked with the unyielding management of the emotional fan attachment to this cultural icon, which would later become a burden in the face of fan incredulity when she failed to conform to this heavily commodified image later in life.")]), _vm._v(" "), _c('p', [_vm._v("While Carrie Fisher wrestled with her own insecurities surrounding her appearance, she also had to make peace with her oft-conflated though extremely humbling appropriation as nostalgic talisman within the fan base. The pseudointimacy fashioned by various comic con and sci-fi convention appearances not only bred further fan connection and kinship to Fisher as object but was also an emblematic fusion of Fisher’s love-hate relationship with the character. Celebrities often cite eccentric fans mistakenly fusing their public personas with their private selves, but this incongruous internalized "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "37",
      "id": "p37",
      "role": "doc-pagebreak"
    }
  }), _vm._v("impression of a personal connection to a character was perpetuated on Carrie Fisher tenfold. Whether as former sexual object, feminist heroine, or figure of childhood nostalgia, the actress felt these appearances bordered on prostitution—a “celebrity lap dance,” she called it; and yet, at the same time, “incredibly sweet and mystifying.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en80",
      "id": "en80r",
      "role": "doc-noteref"
    }
  }, [_vm._v("39")])]), _vm._v(" Sentimental remembrances and personal affected responses to "), _c('i', [_vm._v("Star Wars")]), _vm._v(" dogged each of her appearances, and she was often pressured to render herself as Princess Leia and not Carrie Fisher: “Initially it was very weird to me, because they’re saying you and it’s Leia but to them it’s you and Leia. Over the years, they both get mixed up.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en81",
      "id": "en81r",
      "role": "doc-noteref"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', [_vm._v("Moreover, Fisher noted, “[Fans] also frequently want you to write a piece of dialogue, and that is how I first came to understand who they thought Leia was.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en82",
      "id": "en82r",
      "role": "doc-noteref"
    }
  }, [_vm._v("41")])]), _vm._v(" Further problematizing this conflation was the disappointment and resentment Fisher earned when she unsuccessfully tried to distinguish herself from the character she once played:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("I wish I’d understood the kind of contract I signed by wearing [the metal bikini], insinuating I would and will always remain somewhere in the erotic ballpark appearance-wise, enabling fans to remain connected to their younger, yearning selves—longing to be with me without having to realize that we’re both long past all of this in any urgent sense, and accepting it as a memory rather than an ongoing reality."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en83",
      "id": "en83r",
      "role": "doc-noteref"
    }
  }, [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("As explained by journalist Chris Taylor in his book "), _c('i', [_vm._v("How Star Wars Conquered the Universe")]), _vm._v(", Fisher was cognizant early on that her acting “career had stalled outside of this caricature.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en84",
      "id": "en84r",
      "role": "doc-noteref"
    }
  }, [_vm._v("43")])]), _vm._v(" Despite a successful writing career outside of the "), _c('i', [_vm._v("Star Wars")]), _vm._v(" universe, forty years on, Carrie Fisher was still a mere caricature—the real-life embodiment of a cultural text—and ultimately forced to placate fans and give in to the misappropriation of her identity.")]), _vm._v(" "), _c('p', [_vm._v("Still, despite Fisher’s acerbic attitude toward constantly wrestling with her celebrity status and the products that bore her likeness, she remained grateful to be irrevocably tied to one of the biggest media franchises in the world. In "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(" she writes:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("It turns out that it/she matters to me. Leia. Unfortunately. . . . But as it happens, I’ve spent the lion’s share of my life, . . . being as much myself as Princess Leia. Answering questions about her, defending her, fed up with being mistaken for her, overshadowed by her, struggling "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "38",
      "id": "p38",
      "role": "doc-pagebreak"
    }
  }), _vm._v("with my resentment of her, . . . wishing she’d finally just go away and leave me to be myself alone, but then wondering who I’d be without her, . . . feeling honored to be her representative here on earth, her caretaker, . . . doing what I can to be worthy of the gig, and then feeling beyond ridiculous and wishing that it would just fade away, leaving me to be who I was all those years ago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en85",
      "id": "en85r",
      "role": "doc-noteref"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("But while Fisher is certainly protective of the avatar she embodied all those years ago and recognizes the cultural significance of Princess Leia to fans, the lack of distinction between Carrie Fisher and Princess Leia was never more apparent than when she returned to her infamous role in "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" of 2015 and faced intense scrutiny over having failed to remain frozen in time and desecrating her image with age."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en86",
      "id": "en86r",
      "role": "doc-noteref"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0203"
    }
  }, [_vm._v("When Princess Leia Failed the Ideal Beauty Test")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("While fans were ecstatic when it was revealed that the “old” "), _c('i', [_vm._v("Star Wars")]), _vm._v(" cast would reprise their roles in "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(", Carrie Fisher spoke candidly with "), _c('i', [_vm._v("Good Housekeeping")]), _vm._v(" (UK) that her return was dependent on losing over thirty-five pounds, which Fisher said was the equivalent of asking her to “get younger.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en87",
      "id": "en87r",
      "role": "doc-noteref"
    }
  }, [_vm._v("46")])]), _vm._v(" The film’s producers were not the only ones to take Fisher to task for not “aging well” or “letting herself go,” as Kristen Anderson Wagner recounts in her essay in this anthology. The fan giddiness over seeing the “ageless” Harrison Ford enter the Millennium Falcon in the first trailer was tempered by the unflattering response to Fisher’s own minute presence in it and later during the subsequent press tour.")]), _vm._v(" "), _c('p', [_vm._v("Despite the fact that Fisher did lose the weight as asked, some (male) fans took to social media to completely scrutinize and attack her looks. The biggest culprit was "), _c('i', [_vm._v("New York Post")]), _vm._v(" critic Kyle Smith, who rudely chastised Fisher for rebuking Hollywood’s image-conscious nature, saying that she should just be grateful to simply still have a job—one that, of course, was dependent on her looks in the first place. Smith nastily writes:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("No one would know the name Carrie Fisher if it weren’t for her ability to leverage her looks. George Lucas only cast her in the first place because she was young, slim and cute at the time. . . . Fisher made millions off being pretty. Far from being bitter about this, she and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "39",
      "id": "p39",
      "role": "doc-pagebreak"
    }
  }), _vm._v("other actresses who profited nicely from their looks should be grateful they had a turn at the top."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en88",
      "id": "en88r",
      "role": "doc-noteref"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Aging has long been recognized as a negative aspect of celebrity careers, one exacerbated by the ecology associated with maintaining one’s star status and the preternatural condition of a particular image transfixed on screen."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en89",
      "id": "en89r",
      "role": "doc-noteref"
    }
  }, [_vm._v("48")])]), _vm._v(" Body image, an ideal beauty standard, and ageism have raised concern and outrage among a number of (young "), _c('i', [_vm._v("and")]), _vm._v(" old) actresses within Hollywood. Add to that the rising volume of female fan voices excoriating the toxic sexism rampant within popular (and geek) culture, and the “trouble with Fisher as Leia” is even more cause for distress.")]), _vm._v(" "), _c('p', [_vm._v("While the debate surrounding Princess Leia has vacillated from feminist role model to sexually objectified damsel, the release of "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" renewed the heroine paradox—“heroines are unlike other women in their agentic characteristics but [must also be] ‘quintessentially feminine.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en90",
      "id": "en90r",
      "role": "doc-noteref"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" highlighted Leia’s role as wife, mother, and now, General of the Rebel Alliance. "), _c('i', [_vm._v("Salon")]), _vm._v(" writer Mary Elizabeth Williams saw this “new” Princess Leia as a call to action and praised "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" for giving a “grown woman . . . permission to look like a grown woman.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en91",
      "id": "en91r",
      "role": "doc-noteref"
    }
  }, [_vm._v("50")])]), _vm._v(" But most male fans did not see it that way.")]), _vm._v(" "), _c('p', [_vm._v("Fisher herself understood some of the rancor. Prior to "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" casting announcement, Fisher was ready to move on from the character that had overshadowed her life and that she no longer physically embodied:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Here we are enacting our very own Dorian Gray configuration. You: smooth, certain, and straight-backed, forever condemned to the vast, enviable prison of intergalactic adventure. Me: struggling more and more with post-galactic stress disorder, bearing your scars, graying your eternally dark, ridiculous hair. You always act the heroine; I snort the stuff in the feeble attempt to dim the glare of your intense, intergalactic antics. You take the glory; I give way to age. . . . Though you are condemned to reenact the same seven hours of adventures over a span of now almost four rowdy decades, at least you look good fighting evil. I look lived in."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en92",
      "id": "en92r",
      "role": "doc-noteref"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("And yet, that attitude changed once she recommitted to the character. Fisher responded to the haters with the infamous “Blow us” tweet"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en93",
      "id": "en93r",
      "role": "doc-noteref"
    }
  }, [_vm._v("52")])]), _vm._v(" discussed at "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "40",
      "id": "p40",
      "role": "doc-pagebreak"
    }
  }), _vm._v("length by Kristen Anderson Wagner later in this volume."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en94",
      "id": "en94r",
      "role": "doc-noteref"
    }
  }, [_vm._v("53")])]), _vm._v(" Ever the vociferous humorist, Fisher also wrestled with how to deal, once more, with the commodified image of her likeness—one petrified in sci-fi history:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("[It was] a scornful reminder of just how old you’re getting and how fat you’ve gotten—not only a reminder of what you once were but also of what you no longer are and never will be again. And, as if that wasn’t enough, some stranger "), _c('i', [_vm._v("owns")]), _vm._v(" this horrific image and is free to do whatever with it in private or with his friends."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en95",
      "id": "en95r",
      "role": "doc-noteref"
    }
  }, [_vm._v("54")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In his book "), _c('i', [_vm._v("Celebrity")]), _vm._v(", sociologist Chris Rojek comments on the ways in which the aging celebrity parallels that of the fan base growing up: “celebrities function not only as objects of desire but as objects of nostalgia that can be further commodified by the market.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en96",
      "id": "en96r",
      "role": "doc-noteref"
    }
  }, [_vm._v("55")])]), _vm._v(" Moreover, media scholar Kirsty Fairclough argues that “in an increasingly individualistic culture, a woman’s outward appearance represents her entire selfhood.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en97",
      "id": "en97r",
      "role": "doc-noteref"
    }
  }, [_vm._v("56")])]), _vm._v(" Therefore, it was not surprising that Carrie Fisher became vilified for aging by a fan base encumbered by a nostalgic image of her likeness, but she did feel a bit demoralized by the quick descent into online harassment. Fisher mockingly asked, “Why did all these men find it so easy to be in love with me then and so complex to be in love with me now?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en98",
      "id": "en98r",
      "role": "doc-noteref"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', [_vm._v("And it was not just Fisher who faced such online ridicule; Daisy Ridley (who plays a very benignly—if not practically—costumed Rey) was also body-shamed with regard to her “lack of curves,” with critics writing that she was not a “real woman” and instead was “setting unrealistic expectations for young girls.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en99",
      "id": "en99r",
      "role": "doc-noteref"
    }
  }, [_vm._v("58")])]), _vm._v(" Hence, the criticism of Ridley is evidence that the double standard surrounding Carrie Fisher—and by extension Princess Leia—was not simply about “aging well” but also a general paradox when it comes to the expectations of our on-screen heroines, particularly since none of their male counterparts meet with this same scrutiny.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0204"
    }
  }, [_vm._v("A Woman’s Place Is in the Resistance")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The paratexts created to help hype the return of the beloved "), _c('i', [_vm._v("Star Wars")]), _vm._v(" franchise have greatly perpetuated the sexist hierarchies in the "), _c('i', [_vm._v("Star Wars")]), _vm._v(" fan community. The constant regaling of journalists that "), _c('i', [_vm._v("The Force Awakens")]), _vm._v(" broke boundaries and was “not just for boys anymore” merely drives the "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "41",
      "id": "p41",
      "role": "doc-pagebreak"
    }
  }), _vm._v("marginalization of female fans—as if they, too, need to be rescued by the corporate bigwigs who deign to recognize them as a viable demographic. But why is this still a thing? Why are young girls and women still made to feel like they don’t belong in geek culture, made fun of for wanting to cosplay their favorite characters or bring a "), _c('i', [_vm._v("Star Wars")]), _vm._v(" lunchbox to school? And how does Carrie Fisher’s commodified image further highlight and codify a burgeoning resistance to this patriarchal corporate power?")]), _vm._v(" "), _c('p', [_vm._v("In the same way that popular culture heroines are relegated to buxom costumes, hyperfeminized, and rarely made the hero of their own journey, female fans are forced to navigate the gendered tensions that exist in fandom that highlight its male exclusivity. This gendered hierarchy has been constructed over time by social, economic, and political institutions that leech into popular culture. Hence, it is unsurprising that after her unexpected death in December 2016, Carrie Fisher’s cult status as sci-fi heroine was reimagined as feminist hero of numerous contemporary causes, including the Women’s March. The various eulogies that accompanied Fisher’s death, particularly those written by female fans, expressed a deep-seated understanding of not only the preeminence of the character of Princess Leia but also the personal affliction that Fisher bore as the embodiment of this heroine.")]), _vm._v(" "), _c('p', [_vm._v("Even prior to Fisher’s death, attempts at refurbishing the character of Princess Leia for modern times were underway. In "), _c('i', [_vm._v("Elle")]), _vm._v(", Glynnis Macnicol wrote a rousing defense of Leia as feminist icon, one idolized for her accessibility and take-charge attitude amid a clearly masculine hero’s journey narrative."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en100",
      "id": "en100r",
      "role": "doc-noteref"
    }
  }, [_vm._v("59")])]), _vm._v(" With regard to the merchandise, the postfeminist twenty-first century envisioned Leia as a “self-rescuing princess” on t-shirts and witnessed the rise of Leia-moms—“female fans who grew up with the original series and [were] now strong, smart, powerful role models in their own right.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en101",
      "id": "en101r",
      "role": "doc-noteref"
    }
  }, [_vm._v("60")])]), _vm._v(" In a study of "), _c('i', [_vm._v("Star Wars")]), _vm._v(" fans, Jason Davis and Larry Pakowski noted one fan said, “I like a smart-ass woman who can shoot a gun, negotiate treaties, pose undercover as a bounty hunter, have two guys fighting over her, and still have awesome hair.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en102",
      "id": "en102r",
      "role": "doc-noteref"
    }
  }, [_vm._v("61")])]), _vm._v(" And in her remembrance of Carrie Fisher for the "), _c('i', [_vm._v("Baltimore Sun")]), _vm._v(", Meredith Woerner spoke devotedly of Princess Leia: “Leia proved that you don’t have to choose between being the damsel in distress and the hero; you can be both. You could be the princess and the rebel, the peacemaker and the general.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en103",
      "id": "en103r",
      "role": "doc-noteref"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', [_vm._v("The adoration for Princess Leia was matched with personal admiration for Carrie Fisher. NBC News correspondent Adam Howard noted that "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "42",
      "id": "p42",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Fisher was herself a feminist icon: “[Fisher] defiantly marched to the beat of her own drum, especially off-screen, where her blunt-spoken, no-nonsense persona made her a distinct voice in Hollywood, particularly when it came to issues of sexism and ageism.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en104",
      "id": "en104r",
      "role": "doc-noteref"
    }
  }, [_vm._v("63")])]), _vm._v(" Quoted in Howard’s article, filmmaker Naomi McDougall Jones memorialized Fisher’s brash persona and willingness to embrace her messy "), _c('i', [_vm._v("real")]), _vm._v(" life: Fisher took “the sex-symbol image off the pedestal and flipp[ed] it on its head.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en105",
      "id": "en105r",
      "role": "doc-noteref"
    }
  }, [_vm._v("64")])]), _vm._v(" Aside from noting her indelible connection to Princess Leia—something Fisher omnisciently predicted with regard to her eventual death—some eulogized Carrie Fisher as advocate for political causes that were not necessarily de rigueur for celebrities, particularly as an outspoken advocate for issues of mental health and substance abuse. Prior to her death, Fisher was also a candid challenger to President Donald Trump, his policies, and his venomous use of social media. For all intents and purposes, this overwhelming grief for a newly lost feminist icon and adoration for a feisty arbiter of celebrity and social causes emboldened female fans once more to use Fisher’s image as cultural icon; this time not as nostalgic talisman, but as warrior princess.")]), _vm._v(" "), _c('p', [_vm._v("In the wake of the sexist undertones of a contentious election, Donald Trump’s misogynistic statements and likely future policies caused a rebellion of mostly female protesters to challenge his nascent presidency by demonstrating in full force the day after his presidential inauguration in January 2017. The Women’s March advocated for increased legislation regarding women’s rights—particularly, reproductive rights—as well as health care and immigration reform. It became a global demonstration composed of nearly five million people. But as described by Tanya D. Zuk in her essay in this anthology, it was the surprising appearance of images of Princess Leia (and therefore Carrie Fisher) that captured the attention of many. Despite the fact that a number of celebrity activists promoted and heavily participated in the marches, it was the visage of Carrie Fisher that led to a convergence of pop culture history with feminist rebellion. Fisher’s death inspired Mississippi designer Hayley Gilmore to fashion the graphic of “a faded, red image of Leia clutching her blaster and staring down the camera loomed behind the slogan ‘A Woman’s Place is in the Resistance’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en106",
      "id": "en106r",
      "role": "doc-noteref"
    }
  }, [_vm._v("65")])]), _vm._v(" (see figure 5.1). Gilmore admired that Fisher was “very vocal about what’s been going on recently with the election. She’s honest. To me that’s important. To be open and honest and transparent about what’s going on right now. She’s become an icon.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en107",
      "id": "en107r",
      "role": "doc-noteref"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "43",
      "id": "p43",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Similarly, Los Angeles–based artist Vanessa Witter also found her Carrie Fisher–inspired poster “We Are the Resistance” taken up by demonstrators—some of whom, among the sea of pink “pussyhats”—dressed up as Princess Leia in cities all over the world. Witter’s black-and-white image of a stoic Leia in a white dress and twin hair buns brazenly looking forward, hands at the back of her neck with “we are the resistance” emboldened in red and white underneath feels like a woman on the verge. A woman (and princess) ready to assert herself against the tyranny of galactic patriarchy.")]), _vm._v(" "), _c('p', [_vm._v("A personal interview with Witter further examined the fusion of the Fisher-as-Leia conundrum. Asked if it was Carrie Fisher or Princess Leia "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "44",
      "id": "p44",
      "role": "doc-pagebreak"
    }
  }), _vm._v("who sparked the creative impulse, Witter thoughtfully reasoned that Fisher was the ultimate catalyst for the poster:")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0202"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/wsu-mizejewski-fig0202.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p43"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0008#rfig0202"
    }
  }, [_vm._v("Fig. 2.2.")])]), _vm._v(" The image of Carrie Fisher taken up by demonstrators at the 2017 Women’s March.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("[Fisher] had just recently died and we were all grieving her sudden loss and reflecting on her life. . . . Her personal life was a dichotomy of strength and vulnerability, which we can all relate to on some level, and so many women were feeling both of those things very acutely in the wake of the 2016 election. So while the image on my poster is Princess Leia—leader of the rebellion and feminist heroine—it carries the cultural and emotional weight that it did because of Fisher."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en108",
      "id": "en108r",
      "role": "doc-noteref"
    }
  }, [_vm._v("67")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Carrie Fisher—as Princess Leia—became a recognizable avatar of the Women’s March, converting the cultural cachet of the iconic figure from commodity to an embodiment of “feminine power and leadership” and materializing a new “symbol of hope” for more than just fans, but women in general."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en109",
      "id": "en109r",
      "role": "doc-noteref"
    }
  }, [_vm._v("68")])]), _vm._v(" The generational impact of Princess Leia combined with Carrie Fisher’s own spirited activism now would be forever linked to a renewed wave of feminist protest and solidified the movement.")]), _vm._v(" "), _c('p', [_vm._v("It is likely that the protesters who took part in the global Women’s March did not fully understand the magnitude of co-opting the image of Carrie Fisher as Princess Leia for their handmade signs and t-shirts. They probably were not aware that this gesture of mobilizing their grief in a constructive manner would signify more than a cult appreciation for a cultural text. This was not only a sign (both literally and figuratively) of a feminist rebellion for women’s rights, it was also a chance to wrest control of Carrie Fisher’s likeness away from the corporate overlords who had commodified her image for years to sell licensed merchandise. Gilmore did allude to some legal issues she faced with copyright infringement from Lucasfilm/Disney in an interview with the "), _c('i', [_vm._v("New York Observer")]), _vm._v(";"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en110",
      "id": "en110r",
      "role": "doc-noteref"
    }
  }, [_vm._v("69")])]), _vm._v(" however, fan practices have continually walked a fine line in repurposing corporate-owned intellectual property."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en111",
      "id": "en111r",
      "role": "doc-noteref"
    }
  }, [_vm._v("70")])]), _vm._v(" Fisher’s influence on multiple generations of women was making itself known, not through the economics of merchandise but through a recasting of the twenty-first century as the heroine’s journey. Princess Leia’s pertinent role in a "), _c('i', [_vm._v("real")]), _vm._v(" revolution for human rights was highlighted.")]), _vm._v(" "), _c('p', [_vm._v("The story of Carrie Fisher may seem convoluted to many and was certainly humorously censured by the actress herself. But despite her autobiographies continually alluding to the problematic nature of her personal "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "45",
      "id": "p45",
      "role": "doc-pagebreak"
    }
  }), _vm._v("celebrity—one rife with an accoutrement of licensed products bearing her image—Fisher deserves to be remembered for more than a passing resemblance to a character she once embodied. As she would tell fans at signings:")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0203"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/wsu-mizejewski-fig0203.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p45"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0008#rfig0203"
    }
  }, [_vm._v("Fig. 2.3.")])]), _vm._v(" The generational magnitude of recasting Fisher for the feminist rebellion.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("I’ll sign it Princess Leia. But you do know I’m not "), _c('i', [_vm._v("actually")]), _vm._v(" her, right? I might resemble this character that doesn’t really exist offscreen and in human form—well, maybe I don’t resemble her quite as much as I "), _c('i', [_vm._v("used")]), _vm._v(" to, but for a while there I looked almost "), _c('i', [_vm._v("exactly")]), _vm._v(" like her."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en112",
      "id": "en112r",
      "role": "doc-noteref"
    }
  }, [_vm._v("71")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Carrie Fisher’s memorialization through the Women’s March is an enduring symbol of resonance with female fans and Fisher’s own legacy of "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "46",
      "id": "p46",
      "role": "doc-pagebreak"
    }
  }), _vm._v("activism—both for herself and others. Does this finally answer the question of “Who owns Carrie Fisher?” Likely not. Even though the original intention of the imagery used for the march was merely to craft a tribute to the pop culture heroine, it has, in the interim, become commodified once more with unauthorized permissions by third parties now selling the artwork for profit online."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en113",
      "id": "en113r",
      "role": "doc-noteref"
    }
  }, [_vm._v("72")])]), _vm._v(" But the signification of Fisher’s facetious meditation on her celebrity status and commodification in her autobiographies, combined with fans’ own mediation of her image for either purposes of nostalgia or activism, is a testament to the ways in which a celebrity becomes a custodian of our cultural heritage and "), _c('i', [_vm._v("not")]), _vm._v(" the conglomerations that leverage them for economic value. As Carrie Fisher understood, “I would never not be Princess Leia. I had no idea how profoundly true that was and how long forever was.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/wsumidejewski0012#en114",
      "id": "en114r",
      "role": "doc-noteref"
    }
  }, [_vm._v("73")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "doc-endnotes"
    }
  }, [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0205"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en42r",
      "id": "en42",
      "role": "doc-backlink"
    }
  }, [_vm._v("1")]), _vm._v(" Carrie Fisher, "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(" (New York: Simon & Schuster, 2008), 87.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en43r",
      "id": "en43",
      "role": "doc-backlink"
    }
  }, [_vm._v("2")]), _vm._v(" Ramin Setoodeh, “Carrie Fisher on How George Lucas Stole Her Identity,” "), _c('i', [_vm._v("Newsweek")]), _vm._v(", last modified December 27, 2016, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.newsweek.com/carrie-fisher-george-lucas-star-wars-archive-interview-67321",
      "target": "_blank"
    }
  }, [_vm._v("www.newsweek.com/carrie-fisher-george-lucas-star-wars-archive-interview-67321")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en44r",
      "id": "en44",
      "role": "doc-backlink"
    }
  }, [_vm._v("3")]), _vm._v(" Carrie Fisher, "), _c('i', [_vm._v("The Princess Diarist")]), _vm._v(" (New York: Blue Rider Press, 2016), 194–95.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en45r",
      "id": "en45",
      "role": "doc-backlink"
    }
  }, [_vm._v("4")]), _vm._v(" Mike Fleming Jr., “"), _c('i', [_vm._v("Star Wars")]), _vm._v(" Legacy II: An Architect of Hollywood’s Greatest Deal Recalls How George Lucas Won Sequel Rights,” "), _c('i', [_vm._v("Deadline.com")]), _vm._v(", last modified December 18, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://deadline.com/2015/12/star-wars-franchise-george-lucas-historic-rights-deal-tom-pollock-1201669419/",
      "target": "_blank"
    }
  }, [_vm._v("http://deadline.com/2015/12/star-wars-franchise-george-lucas-historic-rights-deal-tom-pollock-1201669419/")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en46r",
      "id": "en46",
      "role": "doc-backlink"
    }
  }, [_vm._v("5")]), _vm._v(" Brian Warner, “How One Brilliant Decision in 1973 Made George Lucas a Multi-Billionaire Today,” "), _c('i', [_vm._v("Celebrity Net Worth")]), _vm._v(", last modified December 14, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.celebritynetworth.com/articles/entertainment-articles/how-one-genius-decision-made-george-lucas-a-billionaire/",
      "target": "_blank"
    }
  }, [_vm._v("www.celebritynetworth.com/articles/entertainment-articles/how-one-genius-decision-made-george-lucas-a-billionaire/")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en47r",
      "id": "en47",
      "role": "doc-backlink"
    }
  }, [_vm._v("6")]), _vm._v(" Jamal Andress, “The Empire Strikes It Rich: How ‘Star Wars’ Built a Franchise Dynasty,” "), _c('i', [_vm._v("Newsy.com")]), _vm._v(", last modified December 11, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.newsy.com/stories/how-much-is-star-wars-actually-worth/",
      "target": "_blank"
    }
  }, [_vm._v("www.newsy.com/stories/how-much-is-star-wars-actually-worth/")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en48r",
      "id": "en48",
      "role": "doc-backlink"
    }
  }, [_vm._v("7")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 194.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en49r",
      "id": "en49",
      "role": "doc-backlink"
    }
  }, [_vm._v("8")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(", 86–87.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en50r",
      "id": "en50",
      "role": "doc-backlink"
    }
  }, [_vm._v("9")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 34. In "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(", Fisher even jokes that the picture used of her in an abnormal psychology textbook on a chapter regarding bipolar disorder was of Princess Leia with the infamous hairstyle.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en51r",
      "id": "en51",
      "role": "doc-backlink"
    }
  }, [_vm._v("10")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 194.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "47",
      "id": "p47",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en52r",
      "id": "en52",
      "role": "doc-backlink"
    }
  }, [_vm._v("11")]), _vm._v(" Glynnis Macnicol, “In Defense of Princess Leia and ‘Star Wars’ Feminism,” "), _c('i', [_vm._v("Elle")]), _vm._v(", last modified August 14, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.elle.com/culture/career-politics/a29876/in-defense-of-princess-leia-and-star-wars-feminism/",
      "target": "_blank"
    }
  }, [_vm._v("www.elle.com/culture/career-politics/a29876/in-defense-of-princess-leia-and-star-wars-feminism/")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en53r",
      "id": "en53",
      "role": "doc-backlink"
    }
  }, [_vm._v("12")]), _vm._v(" Diana Dominguez, “Feminism and the Force: Empowerment and Disillusionment in a Galaxy, Far, Far Away,” in "), _c('i', [_vm._v("Culture, Identities, and Technology in the Star Wars Films: Essays on the Two Trilogies")]), _vm._v(", ed Carol Silvio and Tony M. Vinci (Jefferson, NC: McFarland, 2007), 109–33.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en54r",
      "id": "en54",
      "role": "doc-backlink"
    }
  }, [_vm._v("13")]), _vm._v(" Camille Bacon-Smith, "), _c('i', [_vm._v("Enterprising Women: Television Fandom and the Creation of Popular Myth")]), _vm._v(" (Philadelphia: University of Pennsylvania Press, 1992); Henry Jenkins, "), _c('i', [_vm._v("Textual Poachers: Television Fans and Participatory Culture")]), _vm._v(" (New York: Routledge, 1992); and for fan consumption, Will Brooker, "), _c('i', [_vm._v("Using the Force: Creativity, Community, and Star Wars Fans")]), _vm._v(" (New York: Continuum, 2002).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en55r",
      "id": "en55",
      "role": "doc-backlink"
    }
  }, [_vm._v("14")]), _vm._v(" Erika Travis, “From Bikinis to Blasters: The Role of Gender in the Star Wars Community,” in "), _c('i', [_vm._v("Fan Phenomena: Star Wars")]), _vm._v(", ed. Mika Elovaara (Bristol: Intellect, 2013), 54.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en56r",
      "id": "en56",
      "role": "doc-backlink"
    }
  }, [_vm._v("15")]), _vm._v(" Jennifer M. Fogel, “The Force Is Now Female: The Gendered Marketing of "), _c('i', [_vm._v("Star Wars")]), _vm._v(",” in "), _c('i', [_vm._v("Beyond Princess Culture: Gender and Children’s Marketing")]), _vm._v(", ed. Katherine Foss (New York: Peter Lang, 2019).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en57r",
      "id": "en57",
      "role": "doc-backlink"
    }
  }, [_vm._v("16")]), _vm._v(" Peter Beech, “Sci fi—It’s Not Just for Boys,” "), _c('i', [_vm._v("The Guardian")]), _vm._v(", last modified May 16, 2009, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.theguardian.com/commentisfree/2009/may/16/science-fiction-men-women",
      "target": "_blank"
    }
  }, [_vm._v("www.theguardian.com/commentisfree/2009/may/16/science-fiction-men-women")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en58r",
      "id": "en58",
      "role": "doc-backlink"
    }
  }, [_vm._v("17")]), _vm._v(" Victoria McNally, “Why 2016 Is the Year We Need to Stop Pretending Women Aren’t Geeks,” "), _c('i', [_vm._v("MTV.com")]), _vm._v(", last modified December 22, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.mtv.com/news/2683640/geek-media-numbers-breakdown/",
      "target": "_blank"
    }
  }, [_vm._v("www.mtv.com/news/2683640/geek-media-numbers-breakdown/")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en59r",
      "id": "en59",
      "role": "doc-backlink"
    }
  }, [_vm._v("18")]), _vm._v(" Joseph Reagle, “Geek Policing: Fake Geek Girls and Contested Attention,” "), _c('i', [_vm._v("International Journal of Communication")]), _vm._v(" 9 (2015): 2866.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en60r",
      "id": "en60",
      "role": "doc-backlink"
    }
  }, [_vm._v("19")]), _vm._v(" Kathleen Day, “Looking for Leia? May the Force Be with You,” "), _c('i', [_vm._v("Washington Post")]), _vm._v(", last modified March 15, 1997, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.washingtonpost.com/wp-dyn/articles/A99038-1997Mar15.html",
      "target": "_blank"
    }
  }, [_vm._v("www.washingtonpost.com/wp-dyn/articles/A99038-1997Mar15.html")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en61r",
      "id": "en61",
      "role": "doc-backlink"
    }
  }, [_vm._v("20")]), _vm._v(" See Suzanne Scott, “#Wheresrey?: Toys, Spoilers, and the Gender Politics of Franchise Paratexts,” "), _c('i', [_vm._v("Critical Studies in Media Communication")]), _vm._v(" 34, no. 2 (2017), for further discussion.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en62r",
      "id": "en62",
      "role": "doc-backlink"
    }
  }, [_vm._v("21")]), _vm._v(" P. David Marshall, "), _c('i', [_vm._v("Celebrity and Power: Fame in Contemporary Culture")]), _vm._v(" (Minneapolis: University of Minnesota Press, 1997), xi.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en63r",
      "id": "en63",
      "role": "doc-backlink"
    }
  }, [_vm._v("22")]), _vm._v(" Richard Dyer, "), _c('i', [_vm._v("Heavenly Bodies: Film Stars and Society")]), _vm._v(" (London: British Film Institute/Macmillan Education, 1986).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "48",
      "id": "p48",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en64r",
      "id": "en64",
      "role": "doc-backlink"
    }
  }, [_vm._v("23")]), _vm._v(" Marshall, "), _c('i', [_vm._v("Celebrity and Power")]), _vm._v(", 18.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en65r",
      "id": "en65",
      "role": "doc-backlink"
    }
  }, [_vm._v("24")]), _vm._v(" Richard Dyer, “"), _c('i', [_vm._v("A Star Is Born")]), _vm._v(" and the Construction of Authenticity,” in "), _c('i', [_vm._v("Stardom: Industry of Desire")]), _vm._v(", ed. Christine Gledhill (London: Routledge, 1991), 136.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en66r",
      "id": "en66",
      "role": "doc-backlink"
    }
  }, [_vm._v("25")]), _vm._v(" Marshall, "), _c('i', [_vm._v("Celebrity and Power")]), _vm._v(", 58.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en67r",
      "id": "en67",
      "role": "doc-backlink"
    }
  }, [_vm._v("26")]), _vm._v(" Dyer, “"), _c('i', [_vm._v("A Star Is Born")]), _vm._v(" and the Construction of Authenticity,” 135.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en68r",
      "id": "en68",
      "role": "doc-backlink"
    }
  }, [_vm._v("27")]), _vm._v(" Marshall, "), _c('i', [_vm._v("Celebrity and Power")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en69r",
      "id": "en69",
      "role": "doc-backlink"
    }
  }, [_vm._v("28")]), _vm._v(" Rosemary Coombe, “The Celebrity Image and Cultural Identity: Publicity Rights and the Subaltern Politics of Gender,” "), _c('i', [_vm._v("Discourse")]), _vm._v(" 14, no. 3 (1992): 59–88.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en70r",
      "id": "en70",
      "role": "doc-backlink"
    }
  }, [_vm._v("29")]), _vm._v(" Coombe, “Celebrity Image and Cultural Identity,” 66.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en71r",
      "id": "en71",
      "role": "doc-backlink"
    }
  }, [_vm._v("30")]), _vm._v(" Coombe, “Celebrity Image and Cultural Identity,” 66.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en72r",
      "id": "en72",
      "role": "doc-backlink"
    }
  }, [_vm._v("31")]), _vm._v(" Jason Scott, “"), _c('i', [_vm._v("Star Wars")]), _vm._v(" as a Character-Oriented Franchise,” in "), _c('i', [_vm._v("Fan Phenomena: Star Wars")]), _vm._v(", ed. Mika Elovaara (Bristol: Intellect, 2013), 11.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en73r",
      "id": "en73",
      "role": "doc-backlink"
    }
  }, [_vm._v("32")]), _vm._v(" Scott, “"), _c('i', [_vm._v("Star Wars")]), _vm._v(" as a Character-Oriented Franchise,” 11.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en74r",
      "id": "en74",
      "role": "doc-backlink"
    }
  }, [_vm._v("33")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 192.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en75r",
      "id": "en75",
      "role": "doc-backlink"
    }
  }, [_vm._v("34")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 5.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en76r",
      "id": "en76",
      "role": "doc-backlink"
    }
  }, [_vm._v("35")]), _vm._v(" Setoodeh, “Carrie Fisher on How George Lucas Stole Her Identity.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en77r",
      "id": "en77",
      "role": "doc-backlink"
    }
  }, [_vm._v("36")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(". In "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(", Fisher recounts the story of George Lucas explaining to her why "), _c('i', [_vm._v("the character")]), _vm._v(" can’t wear a bra in space during "), _c('i', [_vm._v("A New Hope")]), _vm._v(". After making this story a part of her one-woman comedic show, Lucas would later offer Fisher a full technological accounting of why “you can’t wear your brassiere in other galaxies” (Fisher, "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(", 88).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en78r",
      "id": "en78",
      "role": "doc-backlink"
    }
  }, [_vm._v("37")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 38.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en79r",
      "id": "en79",
      "role": "doc-backlink"
    }
  }, [_vm._v("38")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 193.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en80r",
      "id": "en80",
      "role": "doc-backlink"
    }
  }, [_vm._v("39")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 211–13.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en81r",
      "id": "en81",
      "role": "doc-backlink"
    }
  }, [_vm._v("40")]), _vm._v(" Meredith Woerner, “Carrie Fisher Thinks Slave Leia Bikini Haters Are Asinine,” "), _c('i', [_vm._v("Lost Angeles Times")]), _vm._v(", last modified December 17, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.latimes.com/entertainment/herocomplex/la-et-hc-star-wars-carrie-fisher-20151216-story.html",
      "target": "_blank"
    }
  }, [_vm._v("www.latimes.com/entertainment/herocomplex/la-et-hc-star-wars-carrie-fisher-20151216-story.html")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en82r",
      "id": "en82",
      "role": "doc-backlink"
    }
  }, [_vm._v("41")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 226–27.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en83r",
      "id": "en83",
      "role": "doc-backlink"
    }
  }, [_vm._v("42")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 228.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en84r",
      "id": "en84",
      "role": "doc-backlink"
    }
  }, [_vm._v("43")]), _vm._v(" Chris Taylor, "), _c('i', [_vm._v("How Star Wars Conquered the Universe")]), _vm._v(" (New York: Basic Books, 2014), 247.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en85r",
      "id": "en85",
      "role": "doc-backlink"
    }
  }, [_vm._v("44")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 243–44.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en86r",
      "id": "en86",
      "role": "doc-backlink"
    }
  }, [_vm._v("45")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "49",
      "id": "p49",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en87r",
      "id": "en87",
      "role": "doc-backlink"
    }
  }, [_vm._v("46")]), _vm._v(" Ben Child, “Carrie Fisher: I Felt Pressured to Lose Weight for "), _c('i', [_vm._v("Star Wars: The Force Awakens")]), _vm._v(",” "), _c('i', [_vm._v("The Guardian")]), _vm._v(", last modified December 1, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.theguardian.com/culture/2015/dec/01/carrie-fisher-weight-loss-star-wars-the-force-awakens",
      "target": "_blank"
    }
  }, [_vm._v("www.theguardian.com/culture/2015/dec/01/carrie-fisher-weight-loss-star-wars-the-force-awakens")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en88r",
      "id": "en88",
      "role": "doc-backlink"
    }
  }, [_vm._v("47")]), _vm._v(" Kyle Smith, “If Carrie Fisher Doesn’t Like Being Judged on Looks, She Should Quit Acting,” "), _c('i', [_vm._v("New York Post")]), _vm._v(", December 30, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://nypost.com/2015/12/30/if-carrie-fisher-doesnt-like-being-judged-on-looks-she-should-quit-acting/",
      "target": "_blank"
    }
  }, [_vm._v("http://nypost.com/2015/12/30/if-carrie-fisher-doesnt-like-being-judged-on-looks-she-should-quit-acting/")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en89r",
      "id": "en89",
      "role": "doc-backlink"
    }
  }, [_vm._v("48")]), _vm._v(" Barbara L. Marshall and Momin Rahman, “Celebrity, Ageing, and the Construction of ‘Third Age’ Identities,” "), _c('i', [_vm._v("International Journal of Cultural Studies")]), _vm._v(" 18, no. 6 (2014): 577–93.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en90r",
      "id": "en90",
      "role": "doc-backlink"
    }
  }, [_vm._v("49")]), _vm._v(" Suzy D’Enbeau and Patrice M. Buzzanell, “The Erotic Heroine and the Politics of Gender at Work: A Feminist Reading of "), _c('i', [_vm._v("Mad Men")]), _vm._v("’s Joan Harris,” in "), _c('i', [_vm._v("Heroines of Film and Television: Portrayals in Popular Culture")]), _vm._v(", ed. Norma Jones, Maja Bajac-Carter, and Bob Batchelor. (Lanham, MD: Rowman and Littlefield, 2014), 3.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en91r",
      "id": "en91",
      "role": "doc-backlink"
    }
  }, [_vm._v("50")]), _vm._v(" Mary Elizabeth Williams, “"), _c('i', [_vm._v("Star Wars")]), _vm._v(" Lets Princess Leia Age Realistically: Is This an Alternate Hollywood Universe?” "), _c('i', [_vm._v("Salon")]), _vm._v(", Last modified October 20, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.salon.com/2015/10/20/star_wars_lets_princess_leia_age_realistically_is_this_an_alternate_hollywood_universe",
      "target": "_blank"
    }
  }, [_vm._v("https://www.salon.com/2015/10/20/star_wars_lets_princess_leia_age_realistically_is_this_an_alternate_hollywood_universe")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en92r",
      "id": "en92",
      "role": "doc-backlink"
    }
  }, [_vm._v("51")]), _vm._v(" Carrie Fisher, “Character Study: Carrie Fisher Bids Farewell to Princess Leia,” "), _c('i', [_vm._v("BulletMedia")]), _vm._v(", last modified January 4, 2013, http://bullettmedia.com/article/character-study-carrie-fisher-makes-peace-with-princess-leia/ (URL inactive).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en93r",
      "id": "en93",
      "role": "doc-backlink"
    }
  }, [_vm._v("52")]), _vm._v(" Carrie Fisher, Twitter/@carrieffisher: “Please stop debating about whetherOR not [I]aged well.unfortunately it hurts all3 of my feelings.My BODY hasnt aged as well as I have.Blow us,” December 28, 2015.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en94r",
      "id": "en94",
      "role": "doc-backlink"
    }
  }, [_vm._v("53")]), _vm._v(" Sarah Seltzer, “Carrie Fisher Slams Critics of Her Appearance in ‘The Force Awakens,’” "), _c('i', [_vm._v("Flavorwire")]), _vm._v(", last modified December 30, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://flavorwire.com/553819/carrie-fisher-slams-critics-of-her-appearance-in-the-force-awakens",
      "target": "_blank"
    }
  }, [_vm._v("http://flavorwire.com/553819/carrie-fisher-slams-critics-of-her-appearance-in-the-force-awakens")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en95r",
      "id": "en95",
      "role": "doc-backlink"
    }
  }, [_vm._v("54")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 200.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en96r",
      "id": "en96",
      "role": "doc-backlink"
    }
  }, [_vm._v("55")]), _vm._v(" Chris Rojek, "), _c('i', [_vm._v("Celebrity")]), _vm._v(" (London: Reaktion Books, 2001), 189.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en97r",
      "id": "en97",
      "role": "doc-backlink"
    }
  }, [_vm._v("56")]), _vm._v(" Kirsty Fairclough, “Nothing Less Than Perfect: Female Celebrity, Ageing, and Hyper-scrutiny in the Gossip Industry,” in "), _c('i', [_vm._v("Gender, Race and Class in the Media")]), _vm._v(", ed. Gail Dines, Jean M. Humez, Bill Yousman, and Lori Bindig Yousman (London: Sage, 2017), 265.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "50",
      "id": "p50",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en98r",
      "id": "en98",
      "role": "doc-backlink"
    }
  }, [_vm._v("57")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 38.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en99r",
      "id": "en99",
      "role": "doc-backlink"
    }
  }, [_vm._v("58")]), _vm._v(" Jennifer Pearson, “‘I will not apologize for how I look’: "), _c('i', [_vm._v("Star Wars")]), _vm._v(" Star Daisy Ridley Hits Back at Body Shamer Who Ridiculed Her Online for Not Having Curves Like a ‘Real Woman,’” "), _c('i', [_vm._v("Daily Mail")]), _vm._v(", last modified March 9, 2016, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.dailymail.co.uk/tvshowbiz/article-3484676/Daisy-Ridley-hits-body-shamers-complained-s-skinny.html",
      "target": "_blank"
    }
  }, [_vm._v("www.dailymail.co.uk/tvshowbiz/article-3484676/Daisy-Ridley-hits-body-shamers-complained-s-skinny.html")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en100r",
      "id": "en100",
      "role": "doc-backlink"
    }
  }, [_vm._v("59")]), _vm._v(" Macnicol, “In Defense of Princess Leia and ‘Star Wars’ Feminism.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en101r",
      "id": "en101",
      "role": "doc-backlink"
    }
  }, [_vm._v("60")]), _vm._v(" Taylor, "), _c('i', [_vm._v("How Star Wars Conquered the Universe")]), _vm._v(", 49, 55.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en102r",
      "id": "en102",
      "role": "doc-backlink"
    }
  }, [_vm._v("61")]), _vm._v(" Jason Davis and Larry Pakowski, “The Influence of The Force,” in "), _c('i', [_vm._v("Fan Phenomena: Star Wars")]), _vm._v(", ed. Mika Elovaara (Bristol: Intellect, 2013), 99–100.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en103r",
      "id": "en103",
      "role": "doc-backlink"
    }
  }, [_vm._v("62")]), _vm._v(" Meredith Woerner, “Remembering Carrie Fisher: Actress, Writer, Icon,” "), _c('i', [_vm._v("Baltimore Sun")]), _vm._v(", last modified December 27, 2016, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.baltimoresun.com/sdhoy-remembering-carrie-fisher-actress-writer-icon-20161229-story.html",
      "target": "_blank"
    }
  }, [_vm._v("www.baltimoresun.com/sdhoy-remembering-carrie-fisher-actress-writer-icon-20161229-story.html")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en104r",
      "id": "en104",
      "role": "doc-backlink"
    }
  }, [_vm._v("63")]), _vm._v(" Adam Howard, “Carrie Fisher Was a Feminist Force to Be Reckoned With,” "), _c('i', [_vm._v("NBC News")]), _vm._v(", last modified December 27, 2016, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.nbcnews.com/news/us-news/carrie-fisher-was-feminist-force-be-reckoned-n700531",
      "target": "_blank"
    }
  }, [_vm._v("www.nbcnews.com/news/us-news/carrie-fisher-was-feminist-force-be-reckoned-n700531")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en105r",
      "id": "en105",
      "role": "doc-backlink"
    }
  }, [_vm._v("64")]), _vm._v(" Howard, “Carrie Fisher Was.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en106r",
      "id": "en106",
      "role": "doc-backlink"
    }
  }, [_vm._v("65")]), _vm._v(" Joanna Robinson, “How Carrie Fisher Became the Surprising Face of the Rebellion against Trump,” "), _c('i', [_vm._v("Vanity Fair")]), _vm._v(", last modified January 23, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.vanityfair.com/style/2017/01/carrie-fisher-todd-fisher-womens-march-donald-trump",
      "target": "_blank"
    }
  }, [_vm._v("www.vanityfair.com/style/2017/01/carrie-fisher-todd-fisher-womens-march-donald-trump")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en107r",
      "id": "en107",
      "role": "doc-backlink"
    }
  }, [_vm._v("66")]), _vm._v(" Robinson, “How Carrie Fisher Became the Surprising Face.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en108r",
      "id": "en108",
      "role": "doc-backlink"
    }
  }, [_vm._v("67")]), _vm._v(" Vanessa Witter, email message to author, September 19, 2020.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en109r",
      "id": "en109",
      "role": "doc-backlink"
    }
  }, [_vm._v("68")]), _vm._v(" Esther Zuckerman, “‘The Nerds Are Also Here’: Talking With the Women Who Marched With Princess Leia,” "), _c('i', [_vm._v("AV Club")]), _vm._v(", last modified January 24, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://film.avclub.com/the-nerds-are-also-here-talking-to-the-women-who-mar-1798256791",
      "target": "_blank"
    }
  }, [_vm._v("https://film.avclub.com/the-nerds-are-also-here-talking-to-the-women-who-mar-1798256791")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en110r",
      "id": "en110",
      "role": "doc-backlink"
    }
  }, [_vm._v("69")]), _vm._v(" Matthew Corkins, “Princess Leia Poster: Legal Issues Won’t Keep This Artist Out of the Rebellion,” "), _c('i', [_vm._v("New York Observer")]), _vm._v(", last modified February 17, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://observer.com/2017/02/princess-leia-poster-legal-issues-wont-keep-this-artist-out-of-the-rebellion",
      "target": "_blank"
    }
  }, [_vm._v("https://observer.com/2017/02/princess-leia-poster-legal-issues-wont-keep-this-artist-out-of-the-rebellion")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en111r",
      "id": "en111",
      "role": "doc-backlink"
    }
  }, [_vm._v("70")]), _vm._v(" Scott, “"), _c('i', [_vm._v("Star Wars")]), _vm._v(" as a Character-Oriented Franchise.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en112r",
      "id": "en112",
      "role": "doc-backlink"
    }
  }, [_vm._v("71")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 213.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en113r",
      "id": "en113",
      "role": "doc-backlink"
    }
  }, [_vm._v("72")]), _vm._v(" Matthew Corkins, “Princess Leia Poster: Legal Issues Won’t Keep This Artist Out of the Rebellion,” "), _c('i', [_vm._v("New York Observer")]), _vm._v(", last modified February 17, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://observer.com/2017/02/princess-leia-poster-legal-issues-wont-keep-this-artist-out-of-the-rebellion",
      "target": "_blank"
    }
  }, [_vm._v("https://observer.com/2017/02/princess-leia-poster-legal-issues-wont")]), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "51",
      "id": "p51",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://observer.com/2017/02/princess-leia-poster-legal-issues-wont-keep-this-artist-out-of-the-rebellion",
      "target": "_blank"
    }
  }, [_vm._v("-keep-this-artist-out-of-the-rebellion")]), _vm._v(". Even Witter’s “rebellious” art eventually became commodified as for-profit entities appropriated the image for a variety of merchandise. Eventually Witter, too, began to sell screen prints on Etsy to reclaim some control over her art, but she donates a percentage of the sales to progressive causes (Vanessa Witter, email message to author, September 19, 2020).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote",
    attrs: {
      "role": "doc-endnote"
    }
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/wsumidejewski0012#en114r",
      "id": "en114",
      "role": "doc-backlink"
    }
  }, [_vm._v("73")]), _vm._v(" Fisher, "), _c('i', [_vm._v("Princess Diarist")]), _vm._v(", 31.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a740781","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-midejewski-0012.vue
// module id = 87
// module chunks = 0